import { useEffect } from 'react'


import Sections from 'Components/Sections'
import Loading from 'Components/Loading'

import { CLIENT } from 'services/utils'
import Title from 'Components/Title'

import config from '../../../static/Convenio'
import Back from 'Components/Back'
//import { useNavigate } from 'react-router-dom'
import { useHistory } from 'Components/useHistory'

import useConvenios from 'hooks/useConvenios'

const input = { 
    name: 'idConvenio', 
    label: 'descricaoConvenio'
}

const Convenio = () => {

    

    const { getConvenios, selectItem, handleData, data, loading } = useConvenios()

    const { historyPaths } = useHistory()

    historyPaths.add('/convenio')
    
    // const getConvenios = React.useCallback( async () => {
        
    //     try {
            
    //         setLoading(true)

    //         const response = await api.getConvenios()
               
    //         setData(response)

    //     } catch (error) {
    //         console.log(error)
    //         toast.error('Não conseguir listar os convênios nesse momento')    
    //     } finally {
            
    //         setLoading(false)
    //     }
    //     // eslint-disable-next-line
    // }, [setData, setLoading])


    // const selectItem = item => {
        
    //     // const oldItems = data

    //     // if (item.data !== undefined) { 
    //     //     setData(item.data)
    //     //     setIsChildren(true) 
    //     // }

        
    //     setPatient( prevState => {
            
    //         return {
    //             ...prevState, 
    //             [input.name]: item[input.name],
    //             [input.label]: item[input.label],
    //             idPlano: process.env.REACT_APP_ID_PLANO,
    //         }
    //     })
        
    //     setRedirect('/especialidade')
          
    // }

  
    
    useEffect( () => {
        
        getConvenios()
        // eslint-disable-next-line
    }, [getConvenios])
    
    return <>
        <Title title={config[CLIENT].title} />
        <Sections 
            items={data} 
            setItems={handleData}
            totalByPerPage={6} 
            selectItem={selectItem} 
            input={input}
            
        />
        <Back loading={loading} />
        {loading && <Loading />}
    </>
     
}

export default Convenio